import {BaseModel} from "../base";
import {adminSchedule} from "../../services/admin_schedule";

class AdminScheduleModel extends BaseModel {

    constructor(data) {
        super(data);
    }

    /**
     * @description
     * Get post data
     *
     * @returns {array} Returns data.
     */
    getPostData() {
        const data = {};
        data.id = this.id;
        data.rules = this.rules;
        data.name = this.name;
        data.company_id = this.company_id;
        data.duration = this.duration;
        return data;
    }

    static $query(params) {
        return adminSchedule.query(params);
    }

    static $delete(schedule) {
        return adminSchedule.delete(schedule);
    }

    static $update(schedule) {
        return adminSchedule.update(schedule);
    }
}

export {
    AdminScheduleModel
}